import { Epic } from 'redux-observable';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { ofType } from '@alycecom/utils';

import {
  loadGiftTypesRequest,
  loadGiftTypesSuccess,
  loadGiftTypesFail,
  loadCategoriesRequest,
  loadCategoriesSuccess,
  loadCategoriesFail,
  loadBrandsRequest,
  loadBrandsSuccess,
  loadBrandsFail,
} from './filters.actions';
import { IServerFilterOption } from './filters.types';

const getMarketplaceFilterUrl = (
  hashId: string,
  filterType: string,
  countryId: number,
  isDonation: boolean = false,
): string => {
  const marketplacePrefix = isDonation ? '/donation/' : '/';
  return `/api/recipient/${hashId}/marketplace${marketplacePrefix}filters/${filterType}?country_id=${countryId}`;
};

export const loadGiftTypesEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(loadGiftTypesRequest),
    mergeMap(({ payload: { hashId, countryId } }) =>
      apiService.get(getMarketplaceFilterUrl(hashId, 'types', countryId, false)).pipe(
        map((items: IServerFilterOption[]) => loadGiftTypesSuccess(items)),
        catchError(errorHandler({ callbacks: loadGiftTypesFail })),
        takeUntil(action$.ofType(loadGiftTypesRequest)),
      ),
    ),
  );

export const loadCategoriesEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(loadCategoriesRequest),
    mergeMap(({ payload: { hashId, isDonation, countryId } }) =>
      apiService.get(getMarketplaceFilterUrl(hashId, 'categories', countryId, isDonation)).pipe(
        map((items: IServerFilterOption[]) => loadCategoriesSuccess(items)),
        catchError(errorHandler({ callbacks: loadCategoriesFail })),
        takeUntil(action$.ofType(loadCategoriesRequest)),
      ),
    ),
  );

export const loadBrandsEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(loadBrandsRequest),
    mergeMap(({ payload: { hashId, isDonation, countryId } }) =>
      apiService.get(getMarketplaceFilterUrl(hashId, 'vendors', countryId, isDonation)).pipe(
        map((items: IServerFilterOption[]) => loadBrandsSuccess(items)),
        catchError(errorHandler({ callbacks: loadBrandsFail })),
        takeUntil(action$.ofType(loadBrandsRequest)),
      ),
    ),
  );

export const filtersEpics = [loadGiftTypesEpic, loadCategoriesEpic, loadBrandsEpic];
